export default "__VITE_ASSET__d2d89219__"